import React, { useEffect, useState } from "react";
import HeaderSection from "../Navbar/page";
import FooterSection from "../footer/page";
import Api from "../Api/Api";
import { useNavigate } from "react-router-dom";
import { RingLoader } from "react-spinners";

function DemoLeaderboard() {
  const [lastScores, setLastScores] = useState([]); // last week
  const [lastWeekPeriod, setLastWeekPeriod] = useState([]); // last week
  const [thisScores, setThisScores] = useState([]); // this week
  const [thisWeekPeriod, setThisWeekPeriod] = useState([]); // this week
  const [userBestScore, setUserBestScore] = useState(null);

  const [loadingLast, setLoadingLast] = useState(false);
  const [loadingThis, setLoadingThis] = useState(false);
 
  // pagination state per leaderboard
  const itemsPerPage = 10;
  const [currentPageLast, setCurrentPageLast] = useState(1);
  const [currentPageThis, setCurrentPageThis] = useState(1);

  const userIdData = localStorage.getItem("UserIdclient");
  const navigate = useNavigate();

  // safe helpers
  const safeArray = (x) => (Array.isArray(x) ? x : []);
  // derived for Last Week
  const safeLast = safeArray(lastScores);
  // Step 1: sort by rewardAmount descending
  const sortedLast = [...safeLast].sort((a, b) => (b.rewardAmount ?? 0) - (a.rewardAmount ?? 0));

  // Step 2: pagination
  const totalPagesLast = Math.max(1, Math.ceil(sortedLast.length / itemsPerPage));
  const startIndexLast = (currentPageLast - 1) * itemsPerPage;

  // Step 3: slice and map
  const currentItemsLast = sortedLast
    .slice(startIndexLast, startIndexLast + itemsPerPage)
    .map((s, idx) => ({
      id: startIndexLast + idx + 1,   // ranking position
      name: s?.userName ?? "—",             // username from aggregation
      score: s?.rewardAmount != null               // check if exists
      ? `US$ ${s.rewardAmount}`                         // prefix with US$
      : "—"    // reward amount
    }));



  // derived for This Week
  const safeThis = safeArray(thisScores);
  const totalPagesThis = Math.max(1, Math.ceil(safeThis.length / itemsPerPage));
  const startIndexThis = (currentPageThis - 1) * itemsPerPage;
  const currentItemsThis = safeThis
    .slice(startIndexThis, startIndexThis + itemsPerPage)
    .map((s, idx) => ({
      id: startIndexThis + idx + 1,
      name: s?.userId?.userName ?? "—",
      score: s?.score ?? "—",
      timeTaken: s?.timeTaken ?? "—",
    }));

  // page numbers helper
  const makePageNumbers = (currentPage, totalPages, pageLimit = 5) => {
    const currentGroup = Math.floor((currentPage - 1) / pageLimit);
    const startPage = currentGroup * pageLimit + 1;
    const endPage = Math.min(startPage + pageLimit - 1, totalPages);
    const arr = [];
    for (let i = startPage; i <= endPage; i++) arr.push(i);
    return arr;
  };

  const pageNumbersLast = makePageNumbers(currentPageLast, totalPagesLast);
  const pageNumbersThis = makePageNumbers(currentPageThis, totalPagesThis);

  // fetchers
  const getLeaderboardScoreLastWeek = async () => {
    setLoadingLast(true);
    try {
      const res = await Api.get(`/user/demoGame-score-list-lastweek`);
      setLastScores(Array.isArray(res.data.result) ? res.data.result : []);
      setLastWeekPeriod(res.data.message );
      setCurrentPageLast(1);
    } catch (err) {
      console.error("Error fetching last week", err);
      setLastScores([]);
      setLastWeekPeriod("");
    }
    setLoadingLast(false);
  };

  const getLeaderboardScoreThisWeek = async () => {
    setLoadingThis(true);
    try {
      const res = await Api.get(`/user/demoGame-score-list-thisweek`);
      setThisScores(Array.isArray(res.data.result) ? res.data.result : []);
      setThisWeekPeriod(res.data.message );
      setCurrentPageThis(1);
    } catch (err) {
      console.error("Error fetching this week", err);
      setThisScores([]);
      setThisWeekPeriod("");
    }
    setLoadingThis(false);
  };

  const getUserBestScore = async () => {
    try {
      const res = await Api.get(`/user/demoGame-best-score`, {
        params: { userid: userIdData },
      });
      setUserBestScore(res.data.result ?? null);
    } catch (err) {
      console.error("Error fetching user best score", err);
      setUserBestScore(null);
    }
  };

  useEffect(() => {
    getLeaderboardScoreThisWeek();
    getLeaderboardScoreLastWeek();
    getUserBestScore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Inline Leaderboard — unchanged, receives props for each list
  const Leaderboard = ({
    title,
    headings = ["Serial No.", "UserName", "Points", "Timing"],
    scores = [],
    loading = false,
    currentItems = [],
    currentPage = 1,
    totalPages = 1,
    pageNumbers = [],
    handlePagination = () => {}, 
    period = "",
  }) => (
    <div className="leaderboard">
      <h4 className="text-center" style={{ fontSize: "1.1rem" }}>
        {title}
      </h4>
      
      <p className="text-center" style={{ fontSize: "0.85rem", marginTop: 4, color: "#666" }}>
        {period || "—"}
      </p>

      <div
        className="leaderboard-box-1 mt-3 mb-2"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${headings.length}, 1fr)`,
          marginLeft: "6%",
          width: "88%",
        }}
      >
        {headings.map((h, i) => (
          <h5 key={i} style={{ fontSize: "0.9rem", margin: 0 }}>
            {h}
          </h5>
        ))}
      </div>

      {loading ? (
        <div className="d-flex justify-content-center" style={{ padding: 12 }}>
          <RingLoader color="rgb(50 92 213)" size="60px" />
        </div>
      ) : scores.length === 0 ? (
        <div
          className="leaderboard-box1"
          style={{
            marginLeft: "6%",
            width: "88%",
            alignItems: "center",
            border: "1px solid #171f91",
            background: "#171f9121",
            padding: "8px",
            borderRadius: 12,
          }}
        >
          <p className="text-center" style={{ fontSize: "0.85rem", margin: 0 }}>
            No games played yet
          </p>
        </div>
      ) : (
        currentItems.map((row, idx) => (
          <div
            key={row.id + "-" + idx}
            className="leaderboard-box mt-2"
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${headings.length}, 1fr)`,
              marginLeft: "6%",
              width: "88%",
              padding: "8px 0",
            }}
          >
            <p className="text-center" style={{ fontSize: "0.82rem", margin: 0 }}>
              {row.id}
            </p>
            <div className="profil-lead pd-more" style={{ display: "flex", alignItems: "center" }}>
              <h5 style={{ fontSize: "0.85rem", margin: 0 }}>{row.name}</h5>
            </div>
            <p className="text-center" style={{ fontSize: "0.82rem", margin: 0 }}>
              {row.score}
            </p>
            <p className="text-center" style={{ fontSize: "0.82rem", margin: 0 }}>
              {row.timeTaken}
            </p>
          </div>
        ))
      )}

      {scores.length > 0 && totalPages > 1 && (
        <div className="pok-pagination" style={{ marginTop: 8 }}>
          <ul style={{ display: "flex", gap: 8, paddingLeft: 0, listStyle: "none", flexWrap: "wrap" }}>
            {currentPage > 1 && (
              <li>
                <button onClick={() => handlePagination(currentPage - 1)} style={{ fontSize: 12, padding: "6px 8px" }}>
                  <i className="fa-solid fa-angles-left" />
                </button>
              </li>
            )}
            {pageNumbers.map((n) => (
              <li key={n}>
                <button
                  onClick={() => handlePagination(n)}
                  className={currentPage === n ? "active" : ""}
                  style={{
                    fontSize: 12,
                    padding: "6px 8px",
                    background: currentPage === n ? "#304cd5" : "transparent",
                    color: currentPage === n ? "#fff" : "#333",
                    borderRadius: 4,
                    border: "1px solid #ddd",
                  }}
                >
                  {n}
                </button>
              </li>
            ))}
            {currentPage < totalPages && (
              <li>
                <button onClick={() => handlePagination(currentPage + 1)} style={{ fontSize: 12, padding: "6px 8px" }}>
                  <i className="fa-solid fa-angles-right" />
                </button>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <>
      <HeaderSection />
      <section className="call-to-action bettor-ranking overflow-hidden" style={{ marginTop: 80, paddingBottom: 40 }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <Leaderboard
                title="Last Week's Rewards"
                headings={["Position", "UserName", "RewardAmount (US$)"]}
                scores={safeArray(lastScores)}
                loading={loadingLast}
                currentItems={currentItemsLast}
                currentPage={currentPageLast}
                totalPages={totalPagesLast}
                pageNumbers={pageNumbersLast}
                handlePagination={(p) => setCurrentPageLast(p)}
                period={lastWeekPeriod}
              />
            </div>

            <div className="col-lg-6 col-md-6">
              <Leaderboard
                title="This Week's Leaderboard"
                headings={["S.No", "UserName", "Points", "Timing"]}
                scores={safeArray(thisScores)}
                loading={loadingThis}
                currentItems={currentItemsThis}
                currentPage={currentPageThis}
                totalPages={totalPagesThis}
                pageNumbers={pageNumbersThis}
                handlePagination={(p) => setCurrentPageThis(p)}
                period={thisWeekPeriod}
              />
            </div>
          </div>

          {/* Single userBestScore box below both leaderboards */}
          <div style={{ marginTop: 25 }}>
            {userBestScore ? (
              <div
                className="leaderboard-box mt-3"
                style={{
                  display: "grid",
                  gridTemplateColumns: "22% 40% 19% 19%",
                  marginLeft: "6%",
                  width: "88%",
                  border: "2px solid #ff9800",
                  background: "#fff3e0",
                  alignItems: "center",
                  padding: 10,
                  borderRadius: 8,
                }}
              >
                <p className="text-center" style={{ fontSize: 13, margin: 0, fontWeight: 700 }}>
                  ★ My Best Score
                </p>
                <div className="profil-lead pd-more" style={{ display: "flex", alignItems: "center" }}>
                  <h5 style={{ fontSize: 13, margin: 0 }}>{userBestScore?.userId?.userName ?? "—"}</h5>
                </div>
                <p className="text-center" style={{ fontSize: 13, margin: 0 }}>
                  {userBestScore?.score ?? "—"}
                </p>
                <p className="text-center" style={{ fontSize: 13, margin: 0 }}>
                  {userBestScore?.timeTaken ?? "—"}
                </p>
              </div>
            ) : (
              <div
                className="leaderboard-box mt-3"
                style={{
                  gridTemplateColumns: "1fr",
                  marginLeft: "6%",
                  width: "88%",
                  border: "2px solid #ff9800",
                  background: "#fff3e0",
                  textAlign: "center",
                  padding: "10px",
                  borderRadius: 8,
                }}
              >
                <p style={{ margin: 0, fontWeight: 700, color: "#ff9800", fontSize: 13 }}>★ You have not played any games yet</p>
              </div>
            )}
          </div>
        </div>
      </section>
      <FooterSection />
    </>
  );
}

export default DemoLeaderboard;
